// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-styles-___timeElapsed__time___Zjy56{font-family:var(--font-family-tabular)}`, "",{"version":3,"sources":["webpack://./app/styles/timeElapsed.scss"],"names":[],"mappings":"AAEA,yCACE,sCAAA","sourcesContent":["@import 'brandHelper';\n\n.time {\n  font-family: var(--font-family-tabular);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"time": `app-styles-___timeElapsed__time___Zjy56`
};
export default ___CSS_LOADER_EXPORT___;
